import { render, staticRenderFns } from "./mall-stock.vue?vue&type=template&id=a7a8a9a2&scoped=true&"
import script from "./mall-stock.vue?vue&type=script&lang=js&"
export * from "./mall-stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a8a9a2",
  null
  
)

export default component.exports